export const carouselGridSize = {
  KOLO: '96.125',
  TWYFORD: '96.125',
  NORD: '96.125',
  GROUP: '85.125',
};

export const gridSize = {
  KOLO: 'gddsFullGrid',
  TWYFORD: 'gddsFullGrid',
  NORD: 'gddsFullGrid',
  GROUP: 'full',
};

export const tileSizes = {
  quadratic: 's',
  horizontal_1_1: 's',
  horizontal_2_1: 'm',
  event_tile: 's',
};
